function parseAllowedHosts() {
  const raw = process.env.REACT_APP_MEDIA_ALLOWED_HOSTS;
  if (!raw || !String(raw).trim()) return null;

  return new Set(
    String(raw)
      .split(',')
      .map((host) => host.trim().toLowerCase())
      .filter(Boolean)
  );
}

export function isAllowedMediaUrl(fileUrl) {
  if (!fileUrl) return false;

  let parsed;
  try {
    parsed = new URL(fileUrl, window.location.origin);
  } catch {
    return false;
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return false;
  }

  const allowedHosts = parseAllowedHosts();
  if (!allowedHosts) return true;

  return allowedHosts.has(parsed.hostname.toLowerCase());
}
